// api.js
import axios from 'axios';

const API_BASE_URL = window.location.origin;

const api = axios.create({
  baseURL: API_BASE_URL,
});

export default api;
